export default __webpack_public_path__ + "static/media/guide34.24296170.png";